export default {
  staffOnly: 'Staff Only - Requires Admin Approval for Parents',
  staffOnlyForce: 'Staff Only (not visible to parents)'
};
